import React from 'react';
import PropTypes from 'prop-types';

import { getFullReportName } from '../utilities/report-helpers';

const PartnerInsightsReport = ({ name, organisation, subcategories }) => (
  <li className="PartnerInsights_report" key={name}>
    <div className="PartnerInsights_report_title">
      <span>{getFullReportName(name)}</span>
      {/* <button
      type="button"
      className="PartnerInsights_report_info-button"
      onClick={() =>
        this.handleEditAccoutOwnerButton(index)
      }
    >
      <span className="screen-reader">
        Show reports
      </span>
      <SVGIcon icon="info" />
    </button> */}
    </div>
    <ul className="PartnerInsights_report_ul">
      {organisation && organisation.length > 0 && (
        <li className="PartnerInsights_report_li">
          Organisations ({organisation.length})
        </li>
      )}
      {subcategories && subcategories.length > 0 && (
        <li className="PartnerInsights_report_li">
          Subcategories ({subcategories.length})
        </li>
      )}
      {!organisation && !subcategories && (
        <li className="PartnerInsights_report_li">Report Disabled )</li>
      )}
    </ul>
  </li>
);

PartnerInsightsReport.propTypes = {
  name: PropTypes.string.isRequired,
  organisation: PropTypes.arrayOf(PropTypes.string),
  subcategories: PropTypes.arrayOf(PropTypes.string),
};

PartnerInsightsReport.defaultProps = {
  organisation: undefined,
  subcategories: undefined,
};

export default PartnerInsightsReport;
